/**
 * R7: the shared .ls-card window used by today / fame / sectActivities: h3 + close button, a HUD menu-bar button with a
 * kbd hint, open/close/toggle, and a timed refresh. Pure DOM; decides no rule.
 */
import '../loading/loading.css';
import { $, h } from './dom';

/** The "✕" close button of a card header. */
export function cardClose(onClick: () => void): HTMLElement {
  const close = h('button', { type: 'button', ariaLabel: 'ปิด' }, '✕');
  close.addEventListener('click', onClick);
  return close;
}

/** A button in the HUD menu bar (#gmPlay): label, optional kbd hint. */
export function cardMenuButton(id: string, label: string, key: string | undefined, onClick: () => void): HTMLElement {
  const btn = h('button', { type: 'button', id }, h('span', {}, label), ...(key === undefined ? [] : [h('kbd', {}, key)]));
  btn.addEventListener('click', onClick);
  $('#gmPlay').append(btn);
  return btn;
}

export interface LsCardOpts {
  id: string;
  /** Menu label; the header reads `title (key)`. */
  title: string;
  key: string;
  menuId: string;
  /** Seconds between redraws while open. */
  refreshEvery: number;
  draw: (body: HTMLElement) => void;
}

export interface LsCard {
  readonly root: HTMLElement;
  readonly body: HTMLElement;
  readonly isOpen: boolean;
  toggle(): void;
  open(): void;
  close(): void;
  sync(dt: number): void;
  redraw(): void;
}

export function lsCard(o: LsCardOpts): LsCard {
  const body = h('div');
  let t = 0;
  const redraw = (): void => o.draw(body);
  const card: LsCard = {
    root: h('div', { class: 'ls-card', id: o.id, hidden: true }, h('h3', {}, `${o.title} (${o.key})`, cardClose(() => card.close())), body),
    body,
    get isOpen() {
      return !card.root.hidden;
    },
    toggle() {
      if (card.isOpen) card.close();
      else card.open();
    },
    open() {
      card.root.hidden = false;
      t = 0;
      redraw();
    },
    close() {
      card.root.hidden = true;
    },
    sync(dt) {
      if (!card.isOpen || (t -= dt) > 0) return;
      t = o.refreshEvery;
      redraw();
    },
    redraw,
  };
  card.root.addEventListener('pointerdown', (e) => e.stopPropagation());
  $('#hud').append(card.root);
  cardMenuButton(o.menuId, o.title, o.key, () => card.toggle());
  return card;
}
